import React from "react";

export const TransactionsNumberContext = React.createContext({
	transactionsNumber: null,
	setTransactionsNumber: (val?: unknown) => {},
});
